var map = {
	"./carousel-1-old.jpg": "024e",
	"./carousel-1.jpg": "b175",
	"./carousel-2.jpg": "5f34",
	"./logo-old.png": "62fb",
	"./logo-test.png": "a5c7",
	"./logo.jpeg": "dc7c",
	"./mediumLogo.png": "6e28",
	"./placeholder.png": "da7b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";